import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Upload } from "lucide-react";

import nepal from "../../assets/kangaroo/nepalflag.png";
import australia from "../../assets/kangaroo/newzealandflag.png";
import newZealandFlag from "../../assets/kangaroo/newzealandflag.png";
import ukFlag from "../../assets/kangaroo/newzealandflag.png";
import usaFlag from "../../assets/kangaroo/canadaflag.png";
import chinaFlag from "../../assets/kangaroo/newzealandflag.png";
import Dropdown from "../dropdown/Dropdown";
import Button from "../button/Button";
import FormClose from "../FormClose/FormClose";
import Smallbutton from "../button/Smallbutton";
import country from "../../common/data/country";
import { useMutation, useQuery } from "@tanstack/react-query";
import BranchService from "../../services/BranchService";
import Destinationcountry from "../../services/Destinationcountry";
import FormService from "../../services/FormService";
import "./dynamicform.css";
import FormGoldBg from "../FormCloseGold/FormGoldBg";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";

const DynamicInlineForm = ({
  title,
  desc,
  buttondesc,
  btnsize = false,
  isAppointment = false,
  formOrigin,
  ...props
}) => {
  const [countryCode, setCountryCode] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [preferedBranchId, setpreferedBranchId] = useState(null);
  const [callTime, setCallTime] = useState(null);
  const [testPrepClasses, setTestPrepClasses] = useState(null);
  const [interestedPosition, setInterestedPosition] = useState(null);
  const [thankYouModal, setThankYouModal] = useState(false);
  const toggleThankYou = () => setThankYouModal(!thankYouModal);
  const [selectedDate, setSelectedDate] = useState(null)
  const [availableData, setAvailableData] = useState([])
  // Define field order based on props order
  const fields = Object.keys(props).filter((key) => props[key] === true);
  const fetchAvailableSlot = async (date) => {
    if (!date) return;

    try {
      const response = await FormService.getAvailableSlot(
        date.toISOString().split("T")[0] // format as YYYY-MM-DD
      );
      setAvailableData(response);
    } catch (error) {
      console.log("Error fetching slots:", error);
      setAvailableData([]);
    }
  };

  useEffect(() => {
    fetchAvailableSlot(selectedDate);
  }, [selectedDate]);
  // Create dynamic validation schema based on active fields
  const createValidationSchema = () => {
    const schemaFields = {};

    if (props.fullName) {
      schemaFields.fullName = Yup.string()
        .min(2, "Name must be at least 2 characters")
        .max(100, "Name must not exceed 100 characters")
        .matches(/^[a-zA-Z\s]+$/, "Name can only contain letters and spaces")
        .required("Full name is required");
    }

    if (props.email) {
      schemaFields.email = Yup.string()
        .trim()
        .required("Email address is required")
        .matches(
          /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
          "Please enter a valid email address"
        )
        .max(254, "Email address is too long");
    }


    if (props.address) {
      schemaFields.address = Yup.string()
        .required("Address is required")
        .min(10, "Address must be at least 10 characters")
        .max(200, "Address must not exceed 200 characters");
    }

    if (props.phone) {
      schemaFields.phone = Yup.string()
        .transform((value) => (value ? String(value) : "")) // ensure it's a string
        .matches(/^[0-9]+$/, "Phone number must contain only numbers") // no letters/special chars
        .min(10, "Phone number must be at least 10 digits") // minimum 10 digits
        .required("Phone number is required");
    }

    if (props.preferedBranchId) {
      schemaFields.preferedBranchId = Yup.string().required(
        "Please select nearest office"
      );
    }

    if (props.testPrepClasses) {
      schemaFields.testPrepClasses = Yup.string().required(
        "Please select test preparation class"
      );
    }

    if (props.serviceId) {
      schemaFields.serviceId = Yup.string().required(
        "Please select study destination"
      );
    }

    if (props.intendedLevel) {
      schemaFields.intendedLevel = Yup.string().required(
        "Please select study level"
      );
    }

    if (props.callBackTime) {
      schemaFields.callBackTime = Yup.string().required(
        "Please select callback time"
      );
    }

    if (props.testPrep) {
      schemaFields.testPrep = Yup.string().required(
        "Please select test preparation class"
      );
    }

    if (props.interestedPosition) {
      schemaFields.interestedPosition = Yup.string().required(
        "Please select interested position"
      );
    }

    if (props.uploadCV) {
      schemaFields.uploadCV = Yup.mixed()
        .required("Please upload a file")
        .test(
          "fileSize",
          "File size must be less than 5MB",
          (value) => {
            if (!value) return false;
            return value.size <= 5242880; // 5MB
          }
        );
    }


    if (props.message) {
      schemaFields.message = Yup.string().max(
        1000,
        "Message must not exceed 1000 characters"
      );
    }

    return Yup.object().shape(schemaFields);
  };

  // Create initial values based on active fields
  const createInitialValues = () => {
    const values = {};

    if (props.fullName) values.fullName = "";
    if (props.email) values.email = "";
    if (props.address) values.address = "";
    if (props.phone) {
      values.phone = "";
      values.countryCode = "+61";
    }
    if (props.preferedBranchId) values.preferedBranchId = "";
    if (props.testPrepClasses) values.testPrepClasses = "";
    if (props.serviceId) values.serviceId = "";
    if (props.intendedLevel) values.intendedLevel = "";
    if (props.callBackTime) values.callBackTime = "";
    if (props.testPrep) values.testPrep = "";
    if (props.interestedPosition) values.interestedPosition = "";
    if (props.uploadCV) values.uploadCV = null;
    if (props.message) values.message = "";
    if (props.appointment) {
      values.appointment = {
        date: null,
        startTime: null,
        endTime: null,
        selectAnyOne: true, //   explicitly set
      };
    }
    if (props.formOrigin) values.formOrigin = formOrigin;

    return values;
  };

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    try {
      // Ensure phone is a string and add consent
      const payload = {
        ...values,
        phone: String(values.phone),
        consent: true,
        formOrigin: formOrigin,
      };

      // Trigger mutation
      mutation.mutate(payload, {
        onSuccess: () => {
          // Show thank you
          toggleThankYou();

          // Reset the form fields
          resetForm();

          // Reset all dropdown states
          setCountryCode(null);
          setSelectedItem(null);
          setSelectedDestination(null);
          setSelectedLevel(null);
          setSelectedTime(null);
          setpreferedBranchId(null);
          setCallTime(null);
          setTestPrepClasses(null);
          setInterestedPosition(null);
        },
        onSettled: () => {
          // Ensure submitting state is reset even if error occurs
          setSubmitting(false);
        },
        onError: (error) => {
          console.error("Form submission error:", error);
          setSubmitting(false);
        },
      });
    } catch (err) {
      console.error("Unexpected error:", err);
      setSubmitting(false);
    }
  };

  const mutation = useMutation({
    mutationFn: async (formData) => {
      return await FormService.create(formData);
    },
    onError: (error) => {
      console.error("Error submitting form:", error);
    },
    onSuccess: () => {
      console.log("Form submitted successfully");
    },
  });

  const fetchDestinationData = async () => {
    const response = await Destinationcountry.getList();
    return response;
  };

  const fetchOffice = async () => {
    const response = await BranchService.getList();
    return response?.items;
  };

  const { error: officeError, data: officeData } = useQuery({
    queryKey: ["officeData"],
    queryFn: fetchOffice,
    onSuccess: (data) => {
      console.log(data);
    },
  });

  const {
    isPending,
    error,
    data: countryData,
  } = useQuery({
    queryKey: ["countryData"],
    queryFn: fetchDestinationData,
  });

  const officeOptions =
    officeData?.map((item) => ({
      id: item.id,
      label: item.officeName,
    })) || [];

  const countryOptions =
    countryData
      ?.filter((item) => item.isActive)
      ?.map((item) => ({
        id: item.id,
        label: item.name,
      })) || [];

  const renderField = (fieldName, formik) => {
    const {
      values,
      errors,
      touched,
      setFieldValue,
      setFieldTouched,
      handleBlur,
      handleChange,
    } = formik;

    // Common wrapper style for consistent focus/error highlighting
    const getFieldWrapperStyle = () => ({
      borderRadius: "8px",
      transition: "box-shadow 0.3s ease-in-out, border-color 0.3s ease-in-out",
      boxShadow:
        touched[fieldName] && errors[fieldName]
          ? "0 0 0 4px rgba(220, 53, 69, 0.25)" // red glow on error
          : "none",
    });

    // Common input/dropdown style when error
    const getErrorBorderClass = () =>
      touched[fieldName] && errors[fieldName] ? "border-danger" : "";

    switch (fieldName) {
      case "fullName":
      case "email":
      case "address":
      case "interestedPosition":
        const fieldId = fieldName;
        const labelText = {
          fullName: "Full Name*",
          email: "Email Address*",
          address: "Address*",
          interestedPosition: "Interested Position*",
        }[fieldName];

        return (
          <Col sm={12} lg={6} key={fieldName}>
            <div>
              <label htmlFor={fieldId} className="font-label">
                {labelText}
              </label>
              <div style={getFieldWrapperStyle()}>
                <Field
                  type={fieldName === "email" ? "email" : "text"}
                  name={fieldName}
                  id={fieldId}
                  className={`form-control form-box py-3 ${getErrorBorderClass()}`}
                  style={{
                    borderRadius: "8px",
                    border:
                      touched[fieldName] && errors[fieldName]
                        ? "2px solid #dc3545"
                        : "2px solid #687C86",
                  }}
                  onFocus={(e) => {
                    e.target.parentElement.style.boxShadow =
                      "0 0 0 4px rgba(13, 110, 253, 0.25)";
                  }}
                  onBlur={(e) => {
                    handleBlur(e);
                    e.target.parentElement.style.boxShadow =
                      touched[fieldName] && errors[fieldName]
                        ? "0 0 0 4px rgba(220, 53, 69, 0.25)"
                        : "none";
                  }}
                />
              </div>
              <ErrorMessage
                name={fieldName}
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );

      case "phone":
        return (
          <Col sm={12} lg={6} key="phone">
            <div>
              <label className="font-label">Phone Number*</label>
              <div
                style={getFieldWrapperStyle()}
                onFocus={(e) => {
                  e.currentTarget.style.boxShadow =
                    "0 0 0 4px rgba(13, 110, 253, 0.25)";
                }}
                onBlur={(e) => {
                  e.currentTarget.style.boxShadow =
                    (touched.phone && errors.phone) ||
                      (touched.countryCode && errors.countryCode)
                      ? ""
                      : "none";
                }}
              >
                <div className="d-flex">
                  <div style={{ flex: "0 0 6rem" }}>
                    <Dropdown
                      items={country.map((item) => ({
                        id: item.id,
                        label: item.countryCode,
                        flag: item.flagImg,
                      }))}
                      width="9rem"
                      selectedItem={countryCode}
                      setSelectedItem={(item) => {
                        setCountryCode(item);
                        setFieldValue("countryCode", item?.label || null);
                        setFieldTouched("countryCode", true);
                      }}
                      phoneNumber={true}
                      placeholder="+61"
                      placeholderFlag={australia}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Field
                      type="number"
                      name="phone"
                      className={`form-control form-box py-3 ${getErrorBorderClass()}`}
                      style={{
                        borderLeft: "0",
                        borderTopRightRadius: "8px",
                        borderBottomRightRadius: "8px",
                        borderTopLeftRadius: "0",
                        borderBottomLeftRadius: "0",
                        border: "2px solid #687C86",
                        borderLeft: "none",
                      }}
                    />
                  </div>
                </div>
              </div>

              {(errors.phone || errors.countryCode) && touched.phone && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: "0.875rem" }}
                >
                  {errors.countryCode || errors.phone}
                </div>
              )}
            </div>
          </Col>
        );

      // Dropdown fields (all treated similarly)
      case "preferedBranchId":
      case "testPrepClasses":
      case "serviceId":
      case "intendedLevel":
      case "callBackTime":
      case "testPrep":
        const dropdownConfig = {
          preferedBranchId: {
            label: "Nearest KEVS Office*",
            items: officeOptions,
            state: preferedBranchId,
            setState: setpreferedBranchId,
          },
          testPrepClasses: {
            label: "Preferred Test Preparation Classes*",
            items: [
              { id: 1, label: "IELTS" },
              { id: 2, label: "TOEFL" },
              { id: 3, label: "PTE" },
              { id: 4, label: "SAT" },
              { id: 5, label: "GRE" },
              { id: 6, label: "GMAT" },
            ],
            state: testPrepClasses,
            setState: setTestPrepClasses,
          },
          serviceId: {
            label: "What support do you Need?*",
            items: countryOptions,
            state: selectedDestination,
            setState: setSelectedDestination,
          },
          intendedLevel: {
            label: "Preferred Study Level*",
            items: [
              { id: "Bachelor's", label: "Bachelor's" },
              { id: "Master's", label: "Master's" },
              { id: "Masters by Research", label: "Masters by Research" },
            ],
            state: selectedLevel,
            setState: setSelectedLevel,
          },
          callBackTime: {
            label: "What time can we call you back*",
            items: [
              { id: "10 AM - 11 AM", label: "10 AM - 11 AM" },
              { id: "11 AM - 12 PM", label: "11 AM - 12 PM" },
              { id: "12 PM - 1 PM", label: "12 PM - 1 PM" },
              { id: "1 PM - 2 PM", label: "1 PM - 2 PM" },
              { id: "2 PM - 3 PM", label: "2 PM - 3 PM" },
              { id: "3 PM - 4 PM", label: "3 PM - 4 PM" },
              { id: "4 PM - 5 PM", label: "4 PM - 5 PM" },
            ],
            state: callTime,
            setState: setCallTime,
          },
          testPrep: {
            label: "Preferred Test Preparation Classes*",
            items: [
              { id: "IELTS", label: "IELTS" },
              { id: "TOEFL", label: "TOEFL" },
              { id: "PTE", label: "PTE" },
              { id: "SAT", label: "SAT" },
              { id: "GRE", label: "GRE" },
              { id: "GMAT", label: "GMAT" },
            ],
            state: selectedLevel,
            setState: setSelectedLevel,
          },
        }[fieldName];

        return (
          <Col sm={12} lg={6} key={fieldName}>
            <div>
              <label className="font-label">{dropdownConfig.label}</label>
              <div style={getFieldWrapperStyle()}>
                <Dropdown
                  items={dropdownConfig.items}
                  selectedItem={dropdownConfig.state}
                  setSelectedItem={(item) => {
                    const value = item?.id || item?.label || "";

                    // First update internal state (UI)
                    dropdownConfig.setState(item);

                    // Then update Formik
                    setFieldValue(fieldName, value);

                    // Mark as touched — do it after value change
                    setTimeout(() => {
                      setFieldTouched(fieldName, true);
                    }, 0);
                  }}
                  placeholder="Select..."
                />
              </div>
              <ErrorMessage
                name={fieldName}
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );

      case "uploadCV":
        return (
          <Col sm={12} lg={6} key="uploadCV">
            <div>
              <label className="font-label">Upload your CV*</label>
              <div style={getFieldWrapperStyle()}>
                <label
                  htmlFor="uploadCV"
                  className="d-flex justify-content-start ps-3 align-items-center rounded gap-3"
                  style={{
                    backgroundColor:
                      touched.uploadCV && errors.uploadCV
                        ? "#dc3545"
                        : "#687c86",
                    cursor: "pointer",
                    minHeight: "60px",
                    borderRadius: "8px",
                    transition: "background-color 0.3s",
                  }}
                >
                  <Upload />
                  <p className="career-upload-font m-0 text-white py-3">
                    {values.uploadCV ? values.uploadCV.name : "Upload your CV*"}
                  </p>
                </label>
                <input
                  id="uploadCV"
                  name="uploadCV"
                  type="file"
                  accept=".pdf,.doc,.docx"
                  style={{ display: "none" }}
                  onChange={(event) => {
                    setFieldValue("uploadCV", event.currentTarget.files[0]);
                    setFieldTouched("uploadCV", true);
                  }}
                />
              </div>
              <ErrorMessage
                name="uploadCV"
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );
      case "appointment":
        return (
          <>
            {isAppointment && (
              <>
                <div className="d-flex flex-column col-lg-6">
                  {/* Appointment Date */}
                  <div className="mb-3 col-lg-12">
                    <label className="font-label">
                      Select a Date & Time that Suits you*
                    </label>
                    <Flatpickr
                      className="form-control p-3"
                      style={{ border: "1px solid #687C86" }}
                      options={{
                        dateFormat: "Y-m-d",
                        minDate: "today",
                      }}
                      value={values.appointment.date}
                      onChange={([date]) => {
                        setFieldValue("appointment.date", date);
                        setSelectedDate(date);
                      }}
                    />
                  </div>


                </div>

              </>
            )}
          </>
        );
      case "slots":
        if (!formik.values.appointment?.date) return null;
        return (
          <>
            <Row className="mt-0">
              {availableData?.map((slot, index) => (
                <Col key={index} md={3} className="mb-2">
                  <Card
                    onClick={() => {
                      formik.setFieldValue(
                        "appointment.startTime",
                        slot.startTime
                      );
                      formik.setFieldValue(
                        "appointment.endTime",
                        slot.endTime
                      ); // ⚡ set endTime too
                    }}
                    className={`cursor-pointer ${formik.values.appointment.startTime ===
                      slot.startTime
                      ? "border-primary"
                      : ""
                      }`}
                  >
                    <CardBody>
                      {slot.startTime} - {slot.endTime}
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )
      case "message":
        return (
          <Col sm={12} key="message">
            <div>
              <label htmlFor="message" className="font-label">
                Message (if any)
              </label>
              <div style={getFieldWrapperStyle()}>
                <Field
                  as="textarea"
                  name="message"
                  id="message"
                  rows={4}
                  style={{
                    resize: "vertical",
                    borderRadius: "8px",
                    border:
                      touched.message && errors.message
                        ? "2px solid #dc3545"
                        : "2px solid #687C86",
                  }}
                  className={`form-control form-height form-box ${getErrorBorderClass()}`}
                />
              </div>
              <ErrorMessage
                name="message"
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );

      default:
        return null;
    }
  };

  // Group fields into rows (2 columns per row, except message which takes full width)
  const renderRows = (formik) => {
    const rows = [];
    let currentRow = [];

    fields.forEach((field, index) => {
      if (field === "message") {
        if (currentRow.length > 0) {
          rows.push(
            <Row key={`row-${rows.length}`} className="mt-0 border-0">
              {currentRow}
            </Row>
          );
          currentRow = [];
        }
        rows.push(
          <Row key={`row-${rows.length}`} className="mt-3">
            {renderField(field, formik)}
          </Row>
        );
      } else {
        currentRow.push(renderField(field, formik));

        // If we have 2 fields or it's the last field, create a row
        if (currentRow.length === 2 || index === fields.length - 1) {
          rows.push(
            <Row key={`row-${rows.length}`} className="mt-3">
              {currentRow}
            </Row>
          );
          currentRow = [];
        }
      }
    });

    return rows;
  };

  return (
    <Formik
      initialValues={createInitialValues()}
      validationSchema={createValidationSchema()}
      onSubmit={handleSubmit}
      validateOnChange={true}
      validateOnBlur={true}
    >
      {(formik) => (
        <div>
          {renderRows(formik)}
          {/*           
          <div className="mt-4">
            <button
              type="button"
              onClick={handleSubmit}
              className="btn btn-primary px-5 py-2"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div> */}
          <div className="d-flex justify-content-md-end justify-content-start">
            <div
              style={{
                width: "max-content",
                marginTop: "4rem",
                marginBottom: "4rem",
              }}
              onClick={formik.handleSubmit}
            // onClick={toggleThankYou}
            >
              {btnsize ? (
                <div
                  style={{
                    transform:
                      window.innerWidth < 768 ? "scaleY(1.25)" : "none",
                    transformOrigin: "center",
                  }}
                >
                  <Smallbutton text={buttondesc} />
                </div>
              ) : (
                <Button
                  label={buttondesc}
                  margin="20px 0"
                  width="350.4053px"
                  height="60px"
                  fontSize="22px"
                  fontWeight="500"
                  textColor="#890295"
                  fontFamily="Proxima Nova Bold"
                />
              )}
            </div>
            {props.closingFormat === "gold" ? (
              <FormGoldBg
                modal={thankYouModal}
                toggle={toggleThankYou}
                heading="YOU'RE ONE STEP CLOSER TO STARTING SMART!"
                description="Our team will connect with you shortly."
              />
            ) : (
              <FormClose
                modal={thankYouModal}
                toggle={toggleThankYou}
                heading="YOU'RE ONE STEP CLOSER TO STARTING SMART!"
                description="Our counselor will connect with you shortly."
              />
            )}
          </div>
        </div>
      )}
    </Formik>
  );
};

export default DynamicInlineForm;